import BackButton from './BackButton.view';

export default BackButton;
